// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Leaderboard-module__container--XdPNN {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 42px;
}

.Leaderboard-module__leaderboard--oh6Di {
  align-items: stretch;
  border-image-repeat: repeat;
  border-image-slice: 66;
  border-image-source: url("https://p-p.redbull.com/rb-cartoonsorm-widgets-9r-prod/generic/leaderboard_frame.png");
  border-style: solid;
  border-width: 30px;
  display: flex;
  margin: 0 auto;
  margin-bottom: 24px;
  margin-left: auto;
  margin-right: auto;
  min-height: 100%;
  max-width: 400px;
  min-width: 305px;
}

.Leaderboard-module__items--TQ4xF {
  background-color: var(--color-white);
  margin: 0 auto;
  padding: 20px 0 0;
  width: 100%;
}

.Leaderboard-module__item--cVCDq {
  display: flex;
  justify-content: flex-start;
  list-style-type: none;
  overflow: hidden;
  padding: 10px 15px;
}

.Leaderboard-module__item--underlined--No1D8 {
  margin-top: 5px;
  position: relative;

  &::after {
    background: #979797;
    bottom: 0;
    content: "";
    display: inline-block;
    height: 1px;
    left: 0;
    position: absolute;
    right: 0;
  }
}

.Leaderboard-module__item__position--large--DUqzH {
  font-size: 20px;
}

.Leaderboard-module__name--Hj179 {
  display: inline-block;
  padding-left: 30px;

  ul.Leaderboard-module__items--TQ4xF > li:last-child & {
    padding-left: 20px;
  }
}

.Leaderboard-module__score--VT4ml {
  text-align: right;
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Leaderboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,gHAAgH;EAChH,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;;EAElB;IACE,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;;EAElB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  padding: 42px;\n}\n\n.leaderboard {\n  align-items: stretch;\n  border-image-repeat: repeat;\n  border-image-slice: 66;\n  border-image-source: url(\"https://p-p.redbull.com/rb-cartoonsorm-widgets-9r-prod/generic/leaderboard_frame.png\");\n  border-style: solid;\n  border-width: 30px;\n  display: flex;\n  margin: 0 auto;\n  margin-bottom: 24px;\n  margin-left: auto;\n  margin-right: auto;\n  min-height: 100%;\n  max-width: 400px;\n  min-width: 305px;\n}\n\n.items {\n  background-color: var(--color-white);\n  margin: 0 auto;\n  padding: 20px 0 0;\n  width: 100%;\n}\n\n.item {\n  display: flex;\n  justify-content: flex-start;\n  list-style-type: none;\n  overflow: hidden;\n  padding: 10px 15px;\n}\n\n.item--underlined {\n  margin-top: 5px;\n  position: relative;\n\n  &::after {\n    background: #979797;\n    bottom: 0;\n    content: \"\";\n    display: inline-block;\n    height: 1px;\n    left: 0;\n    position: absolute;\n    right: 0;\n  }\n}\n\n.item__position--large {\n  font-size: 20px;\n}\n\n.name {\n  display: inline-block;\n  padding-left: 30px;\n\n  ul.items > li:last-child & {\n    padding-left: 20px;\n  }\n}\n\n.score {\n  text-align: right;\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Leaderboard-module__container--XdPNN`,
	"leaderboard": `Leaderboard-module__leaderboard--oh6Di`,
	"items": `Leaderboard-module__items--TQ4xF`,
	"item": `Leaderboard-module__item--cVCDq`,
	"itemUnderlined": `Leaderboard-module__item--underlined--No1D8`,
	"itemPositionLarge": `Leaderboard-module__item__position--large--DUqzH`,
	"name": `Leaderboard-module__name--Hj179`,
	"score": `Leaderboard-module__score--VT4ml`
};
module.exports = ___CSS_LOADER_EXPORT___;
